<template>
    <div>
        <b-card-actions action-collapse title="House Owner">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label class="owner-label">
                            Owner of property (Search Name, Phone, Email) [
                            <feather-icon
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                @click="openOwnerForm"
                                icon="PlusCircleIcon"
                                class="text-primary cursor-pointer"
                            />
                            ]
                        </label>

                        <vue-autosuggest
                            ref="autocomplete"
                            v-model="searchQuery"
                            :suggestions="suggestions"
                            :input-props="inputProps"
                            :section-configs="sectionConfigs"
                            :render-suggestion="renderSuggestion"
                            :get-suggestion-value="getSuggestionValue"
                            @input="fetchResults"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="selectedOwner">
                <b-col md="6">
                    <b-form-group label="First name">
                        <b>{{ selectedOwner.name || selectedOwner.firstname || '' }}</b>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Last name">
                        <b>{{ selectedOwner.owner_lastname || selectedOwner.lastname || '' }}</b>
                    </b-form-group>
                </b-col>

                <!-- <b-col md="6">
                    <b-form-group label="Email">
                        <b>{{ selectedOwner.owner_email || '' }}</b>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Phone No.">
                        <b>{{ selectedOwner.owner_phone || '' }}</b>
                    </b-form-group>
                </b-col> -->
            </b-row>

            <b-sidebar
                id="sidebar-right"
                bg-variant="white"
                v-model="isSidebarOwnerOpen"
                no-header
                right
                backdrop
                shadow
                ref="formOwner"
                class="side-bar-responsive"
            >
                <template>
                    <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                        <h5 class="mb-0"> Add Owner </h5>
                        <div>
                            <feather-icon
                                class="ml-1 cursor-pointer"
                                icon="XIcon"
                                size="16"
                                @click="closeOwnerForm"
                            />
                        </div>
                    </div>

                    <Owner-form-popup
                        v-if="isSidebarOwnerOpen"
                        @childToOwner="closeOwnerForm"
                    />
                </template>
            </b-sidebar>
        </b-card-actions>
    </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, VBToggle, BSidebar,
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import OwnerFormPopup from '../../users/owner/owner-form/OwnersFormPopup.vue'
import { VueAutosuggest } from 'vue-autosuggest'
import axios from '@axios'
import { MIN_USER_KEYWORD, searchUsers } from '@core/utils/user-autocomplete'

export default {
    props: {
        form: { type: Object, required: true }
    },
    components: {
        BCardActions, BRow, BCol, BFormGroup, BSidebar, OwnerFormPopup, VueAutosuggest,
    },
    directives: {
        'b-toggle': VBToggle,
        Ripple,
    },
    data() {
        return {
            searchQuery: '',
            selectedOwner: null,
            isSidebarOwnerOpen: false,
            suggestions: [],
            inputProps: {
                id: 'autosuggest__input_ajax',
                placeholder: 'Owner of property',
                class: 'form-control',
                name: 'ajax',
            },
            sectionConfigs: {
                owner: {
                    limit: 20,
                    label: 'Owners',
                    onSelected: selected => {
                        console.log('select', selected)
                        const { owner_firstname, owner_lastname } = selected.item
                        this.selectedOwner = selected.item
                        this.form.owner_id = selected.item.id
                        this.searchQuery = owner_lastname
                            ? `${owner_firstname} ${owner_lastname}`
                            : owner_firstname
                        this.emitToParent()
                    },
                },
            },
            timeout: null,
            debounceMilliseconds: 400,
        }
    },
    created() {
        console.log('effefefe', this.form.owner_id)
        if (this.form.owner_id) {
            this.initData();
        }
    },
    methods: {
        async initData() {
            console.log('check id', this.form.owner_id)
            this.fetchExistingUser()
        },
        async fetchExistingUser() {
            try {
                const { data } = await axios.post(`users/v1/lists` ,{
                    id: this.form.owner_id
                })

                const owner = data.data[0];
                console.log('owwwn', owner)
                this.selectedOwner = owner;
                this.form.owner_id = owner.id;
                this.searchQuery = owner.owner_lastname
                    ? `${owner.owner_firstname} ${owner.owner_lastname}`
                    : owner.owner_firstname;
            } catch (error) {
                console.error('add house failed:', error)
            }
        },
        openOwnerForm() {
            this.isSidebarOwnerOpen = true
        },
        closeOwnerForm() {
            this.isSidebarOwnerOpen = false
        },
        renderSuggestion(suggestion) {
            const { owner_firstname, owner_lastname } = suggestion.item
            return owner_lastname
                ? `${owner_firstname} ${owner_lastname}`
                : owner_firstname
        },
        getSuggestionValue(suggestion) {
            const { owner_firstname, owner_lastname } = suggestion.item
            return owner_lastname
                ? `${owner_firstname} ${owner_lastname}`
                : owner_firstname
        },
        fetchResults() {
            // One character matches ~6,000 owners and the endpoint returns all of them; see user-autocomplete.js
            if (this.searchQuery && this.searchQuery.trim().length >= MIN_USER_KEYWORD) {
                clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                searchUsers(this.searchQuery)
                    .then(owners => {
                    this.suggestions = [
                        { name: 'owner', data: owners },
                    ]
                    })
                    .catch(err => {
                    console.error('Autocomplete error:', err)
                    this.suggestions = []
                    })
                }, this.debounceMilliseconds)
            } else {
                this.suggestions = []
            }
        },
        emitToParent() {
            this.$emit('ownerSelected', this.selectedOwner)
        },
    },
    watch: {
        'form.owner_id'(newVal) {
            if (newVal) {
                this.initData();
            }
        }
    }
}
</script>

<style scoped>
.owner-label {
  font-size: 1rem;
}
</style>